<footer
  class='footer'
  [ngClass]="{ 'footer--internal': internal }"
  [style.color]="authService.isAuthenticated() && cService.userProfile?.HqColour ? 'white' : ''"
  [style.background-color]="authService.isAuthenticated() ? '#' + cService.userProfile?.HqColour : ''"
>
  <p *ngIf='!internal' class='footer__logo footer__logo--ico'>
    <img [src]="cService.imageRoot + 'logo_ico.png'" alt='ICO' />
  </p>

  <p *ngIf='!internal' class='footer__logo footer__logo--bsi'>
    <img [src]="cService.imageRoot + 'logo_bsi.png'" alt='BSI' />
  </p>

  <div class='footer__content'>
    <p class='footer__cookies'><a (click)='toggleInfo()'>
      <img *ngIf='!internal' [src]="cService.imageRoot + 'cookie-icon.png'" alt='Cookies' width='40' />
      <img *ngIf='internal' [src]="cService.imageRoot + 'cookie-icon-white.png'" alt='Cookies' width='40' />
    </a></p>
    <div class='footer__detail'>

      <ul class='footer__links'>
        <li><a target='_blank' href='https://www.edriving.com/privacy/'>{{ 'GENERIC.privacyPolicy' | translate }}</a>
        </li>
        <li><a target='_blank'
               href='https://www.edriving.com/cookies-policy-and-settings/'>{{ 'GENERIC.cookiePolicy' | translate }}</a>
        </li>
        <li><a target='_blank' href='https://www.edriving.com/terms-of-use/'>{{ 'GENERIC.termsOfUse' | translate }}</a>
        </li>
      </ul>

      <p class='footer__pii'>{{ 'GENERIC.eDrivingNeverSellsPii' | translate }} - <a target='_blank'
                                                                                    href='https://eudsar.solera.com/webform/9eb91cc4-23fa-42be-9a10-ed84af223018/6c2659c0-9c82-449f-b095-367e4db92d41'>{{ 'GENERIC.exerciseYourRights' | translate }}</a>
      </p>

      <div class='footer__support'>
        <p class='footer__support-link footer__support-link--uk'>{{ 'GENERIC.ukTollFree' | translate }}: +44 800 808
          5611</p>
        <p class='footer__support-link footer__support-link--us'>{{ 'GENERIC.usTollFree' | translate }}:
          +1-855-999-9094</p>
      </div>

      <p class='footer__copyright'><span
        [innerHtml]='cService.copyright'></span> {{ cService.readyTranslations.login.allRightsReserved }}</p>
    </div>
  </div>
</footer>
